<template>
  <div class="app-container">
    <basic-container>
      <el-form label-width="130px" :rules="rules" ref="medalForm" :model="medalForm" size="medium" class="medal-form">
        <el-form-item label="勋章名称" prop="name">
          <el-col :span="15">
            <el-input type="text" placeholder="请输入勋章名称" v-model="medalForm.name" clearable></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="勋章描述" prop="description">
          <el-col :span="15">
            <el-input :rows="2" type="textarea" placeholder="请输入勋章描述" v-model="medalForm.description" clearable></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="勋章分组" prop="medalGroup">
          <el-col :span="15">
            <el-select placeholder="请选择勋章分组" v-model="medalForm.medalGroup" clearable size="small">
              <el-option
                v-for="item in medalGroup"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item label="勋章规则" prop="medalRule">
          <el-col :span="15">
            <el-select placeholder="请选择勋章规则" v-model="medalForm.medalRule" clearable size="small">
              <el-option
                v-for="item in medalRules"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-col>
        </el-form-item>        
        <el-form-item label="勋章图标(未点亮)" prop="unlitUrl">
          <div class="medal-image">
            <div v-if="medalForm.unlitUrl">
              <img class="medal-image-display" :src="medalForm.unlitUrl | ossImageProcess" v-viewer>
              <el-button type="text" @click="medalForm.unlitUrl = ''" icon="icon-remove-image" class="medal-image-remove-btn"></el-button>
            </div>
            <el-button v-else @click="handleMedalUnlitImageChange" icon="icon-add-image" class="medal-image-add-btn"></el-button>
          </div>
        </el-form-item>
        <el-form-item label="勋章图标(点亮)" prop="litUrl">
          <div class="medal-image">
            <div v-if="medalForm.litUrl">
              <img class="medal-image-display" :src="medalForm.litUrl | ossImageProcess" v-viewer>
              <el-button type="text" @click="medalForm.litUrl = ''" icon="icon-remove-image" class="medal-image-remove-btn"></el-button>
            </div>
            <el-button v-else @click="handleMedalLitImageChange" icon="icon-add-image" class="medal-image-add-btn"></el-button>
          </div>
        </el-form-item>
        <el-form-item label="勋章是否分等级">
          <el-col :span="15">
            <el-switch v-model="isGraded"></el-switch>
          </el-col>
        </el-form-item>
        <div class="medal-grade" v-if="isGraded">
          <el-form-item label="勋章等级" prop="grade">
            <el-col :span="15">
              <el-input-number controls-position="right" v-model="medalForm.grade" :min="0" :precision="0"></el-input-number>
            </el-col>
          </el-form-item>
          <el-form-item label="等级名称" prop="gradeName">
            <el-col :span="15">
              <el-input type="text" placeholder="请输入等级名称" v-model="medalForm.gradeName" clearable></el-input>
            </el-col>
          </el-form-item>
        </div>
        <el-form-item label="获取条件" prop="condition">
          <el-col :span="15">
            <el-input-number controls-position="right" v-model="medalForm.condition" :min="0" :precision="0"></el-input-number>
          </el-col>
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-col :span="15">
            <el-input-number controls-position="right" v-model="medalForm.sort" :precision="0"></el-input-number>
            <span class="tips-info" >【提示：数字越小优先级越高】</span>
          </el-col>
        </el-form-item>
        <el-form-item class="operation">
          <el-col :span="15">
            <el-button size="medium" @click="$router.go(-1)">取消</el-button>
            <el-button v-if="!isEdit" size="medium" type="primary" @click="handleCreate">保存</el-button>
            <el-button v-if="isEdit" size="medium" type="primary" @click="handleUpdate">更新</el-button>
          </el-col>
        </el-form-item>
      </el-form>
    </basic-container>
  </div>  
</template>

<script>
import { medalRules } from '@/const/crud/medal/medal'
import { getMedalGroupList, getMedalDetail, createMedal, updateMedal } from '@/api/medal/medal'

export default {
  data () {
    return {
      id: null,
      isEdit: false,
      isGraded: false,
      medalRules,
      medalGroup: [],   
      medalForm: {
        name: '',
        description: '',
        medalGroup: null,
        medalRule: null,
        unlitUrl: '',
        litUrl: '',
        grade: undefined,
        gradeName: '',
        condition: undefined,
        sort: 0,
        isActive: true,
      },
      rules: {
        name: [
          { required: true, message: "请填写勋章名称", trigger: 'blur' },
          { max: 40, message: '长度不超过 40 个字符', trigger: 'change' }
        ],
        description: [
          { max: 40, message: '长度不超过 200 个字符', trigger: 'change' }
        ],
        medalGroup: [
          { required: true, message: "请选择勋章分组", trigger: 'blur' },
        ],        
        medalRule: [
          { required: true, message: "请选择勋章规则", trigger: 'blur' },
        ],
        unlitUrl: [
          { required: true, message: "请选择未点亮状态的勋章图标", trigger: 'change' },
        ],
        litUrl: [
          { required: true, message: "请选择点亮状态的勋章图标", trigger: 'change' },
        ],
        grade: [
          { required: true, message: "请填写勋章等级", trigger: 'change' },
        ],
        gradeName: [
          { required: true, message: "请填写等级名称", trigger: 'blur' },
          { max: 40, message: '长度不超过 40 个字符', trigger: 'change' }
        ],
        sort: [
          { required: true, message: "请填写置顶级别", trigger: 'blur' },
        ],
      },
    }
  },
  async created () {
    await this.loadMedalGroup();
    this.id = this.$route.params.id;
    if(this.id) {
      this.isEdit = true;
      this.getDetail();
    }
  },  
  methods: {
    getDetail() {
      getMedalDetail(this.id).then(res => {
        Object.assign(this.medalForm, res.data.data);
        this.medalForm.medalGroup = res.data.data.groupId;
        this.isGraded = this.medalForm.grade ? true : false;
      }).catch(err => {
        this.$message({
          message: err,
          type: '获取勋章详情失败'
        })
        this.$router.go(-1);
      })
    },    
    handleCreate() {
      this.$refs.medalForm.validate((valid) => {
        if (!valid) return;
        if (!this.isGraded) {
          this.medalForm.grade = undefined;
          this.medalForm.gradeName = '';
          this.medalForm.condition = undefined;
        }
        createMedal(this.medalForm).then(res => {
          this.$message({
            message: '新建勋章成功',
            type: 'success'
          })
          this.$router.go(-1);
        }).catch(err => {
          this.$message({
            message: err,
            type: 'error'
          })
        })
      })
    },
    handleUpdate() {
      this.$refs.medalForm.validate((valid) => {
        if (!valid) return;
        if (!this.isGraded) {
          this.medalForm.grade = undefined;
          this.medalForm.gradeName = '';
          this.medalForm.condition = undefined;
        }
        updateMedal(this.medalForm).then(res => {
          this.$message({
            message: '编辑勋章成功',
            type: 'success'
          })
          this.$router.go(-1);
        }).catch(err => {
          this.$message({
            message: err,
            type: 'error'
          })
        })
      })
    },    
    async loadMedalGroup(){
      const params = {};
      const response = await getMedalGroupList();
      this.medalGroup = response.data.data;
      this.medalGroup.unshift({ id: -1, name: '未分组' });
    },
    handleMedalUnlitImageChange() {
      this.$openMaterialLib((list) => {
        if (list && list.length > 0) {
          this.medalForm.unlitUrl = list[0].contentUrl;
          this.$refs['medalForm'].validateField('unlitUrl');
        }
      }, 1);
    },
    handleMedalLitImageChange() {
      this.$openMaterialLib((list) => {
        if (list && list.length > 0) {
          this.medalForm.litUrl = list[0].contentUrl;
          this.$refs['medalForm'].validateField('litUrl');
        }
      }, 1);
    },     
  }
}
</script>

<style lang="scss" scoped>
.medal-form {
  .tips-info {
    font-size: 12px;
    color: #7d7d7d;
    display: inline-block;
    margin-left:4px;
  }
  .medal-image {
    &-display {
      width: 80px;
      height: 80px;
    }
    &-remove-btn {
      position: absolute;
      padding: 0;
      margin-left: -15px;
    }
    &-add-btn {
      width: 80px;
      height: 80px;
      margin-left: 5px;
    }
  }
  .operation {
    margin: 65px 0px 25px 0px;
    text-align: right!important;
  }
}
</style>